import type { ConfigName } from "../../types/config-name";

export const configName: ConfigName = "free_packages";
